import { client } from "@/lib/httpClient";
import { ROUTES } from "@/constants/routes.constants";
import {Priority} from "@/types/priority.types";

export const prioritiesApi = {
    getAll: async (): Promise<Priority[]> => {
        const response = await client.get<Priority[]>(ROUTES.PRIORITIES.API.BASE);
        return response.data ?? [];
    },
};
